/*
 * @file: historySetup.js
 * @description: Creates redux-first-history context (replaces connected-react-router)
 */

import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({ history: createBrowserHistory() });

export { createReduxHistory, routerMiddleware, routerReducer };
